import lodashTemplate from 'lodash/template'

// Can be used with Lodash or Underscore. We use `<@= … @>` so we can render
// these templates within ERB without conflict.
const templateSettings = {
  interpolate: /<@=(.+?)@>/gim,
  evaluate: /<@([\s\S]+?)@>/gim,
  escape: /<@-(.+?)@>/gim,
}

// This is the preferred variant of _.template. Use it instead of
//
//     import _ from 'lodash'
//     _.template(…)
//
// or
//
//     import template from 'lodash/template'
//     template(…)
//
// or
//
//     import _ from 'underscore'
//     _.template(…)
export default function template(string, options, guard) {
  return lodashTemplate(string, Object.assign({}, options, templateSettings), guard)
}
